import { Col, Container } from "react-bootstrap";
import { GeoAltFill } from "react-bootstrap-icons";
import SectionHeading from "../ui/SectionHeading";
import { RevealGroup, RevealItem } from "../ui/Reveal";
import "../style/WhereToBuy.css";

const BLINKIT_HREF =
  "https://blinkit.com/prn/bit-byte-foods-dosa-paddu-batter/prid/668300";

// Edit this list to add/remove areas — no map or API wired up on purpose,
// this is the whole "store locator" for now.
const AREAS = [
  {
    place: "Bagalkot",
    text: "Our home base. Ask for Bit Byte Foods batter at local retailers near Vidyagiri.",
  },
  {
    place: "Vijayapura",
    text: "Available through our growing network of local retail partners, and on Blinkit.",
    blinkit: true,
  },
  {
    place: "Raichur",
    text: "Available on Blinkit for quick delivery.",
    blinkit: true,
  },
  {
    place: "Dharwad",
    text: "Available on Blinkit for quick delivery.",
    blinkit: true,
  },
  {
    place: "Belgaum",
    text: "Available on Blinkit for quick delivery.",
    blinkit: true,
  },
];

const WHATSAPP_HREF =
  "https://api.whatsapp.com/send?phone=916363018056&text=Hi%2C%20I%27d%20like%20to%20stock%20Bit%20Byte%20Foods%20batter%20at%20my%20store.";

const WhereToBuy = () => {
  return (
    <section id="where-to-buy" className="section-pad where-to-buy">
      <Container className="container-narrow">
        <SectionHeading
          eyebrow="Find Us"
          title="In Stores & On Blinkit Across North Karnataka"
          subtitle="Walk into your usual store in Bagalkot or Vijayapura, or order on Blinkit in Vijayapura, Raichur, Dharwad & Belgaum. Retailer or distributor? Reach out on WhatsApp."
        />
        <RevealGroup className="row g-4 justify-content-center">
          {AREAS.map(({ place, text, blinkit }) => (
            <Col sm={6} md={4} key={place}>
              <RevealItem className="where-to-buy__card card-surface">
                <GeoAltFill size={22} className="where-to-buy__icon" />
                <h3>{place}</h3>
                <p>{text}</p>
                {blinkit && (
                  <a
                    href={BLINKIT_HREF}
                    target="_blank"
                    rel="noreferrer"
                    className="where-to-buy__blinkit"
                  >
                    Order on Blinkit
                  </a>
                )}
              </RevealItem>
            </Col>
          ))}
        </RevealGroup>
        <div className="where-to-buy__cta">
          <a href={WHATSAPP_HREF} target="_blank" rel="noreferrer" className="btn-turmeric">
            Want to Stock It? WhatsApp Us
          </a>
        </div>
      </Container>
    </section>
  );
};

export default WhereToBuy;
